export default "__VITE_ASSET__4rYYvtqD__"